import { NPC } from '../models/LandProfile';
import { Notification } from '../models/Notification';
import { Villager } from '../models/Villager';
import { isLeapDay, isLeapYear, isToday, isTomorrow } from './birthday';

export function createBirthdayNotifications(
  villagers: Villager[],
  npcs: NPC[],
  selectedUserId: string
): Notification[] {
  const thisYear = new Date().getFullYear();

  const myself = villagers.find(v => v.userId === selectedUserId);
  const otherPlayers = villagers.filter(v => !(v.userId && v.userId === selectedUserId));

  const results: Notification[] = [];

  // 自分自身（本日）
  if (myself && isToday({ month: myself.mBirthMonth, day: myself.mBirthDay })) {
    // 誕生日当日の通知は今日が誕生日の人に'birthday-today'の通知を出すが、例外として、うるう年でない年で、誕生日が2/29の人の場合、2/28に誕生日当日の通知を出す。
    // この例外で作成される通知は特別な文言を使用するため、 'birthday-today-leap' で通知を作成する。
    const type =
      !isLeapYear(thisYear) && isLeapDay({ month: myself.mBirthMonth, day: myself.mBirthDay })
        ? 'birthday-today-leap'
        : 'birthday-today';
    results.push({
      type,
      name: myself.mPNm,
      target: 'myself'
    });
  }

  // プレイヤーの島民（本日）
  for (const p of otherPlayers) {
    if (p.screening !== 'ng' && isToday({ month: p.mBirthMonth, day: p.mBirthDay })) {
      const type =
        !isLeapYear(thisYear) && isLeapDay({ month: p.mBirthMonth, day: p.mBirthDay })
          ? 'birthday-today-leap'
          : 'birthday-today';
      results.push({ type, name: p.mPNm, target: 'other' });
    }
  }

  // NPCの島民（本日）
  for (const npc of npcs) {
    if (isToday({ month: npc.birthMonth, day: npc.birthDay })) {
      const type =
        !isLeapYear(thisYear) && isLeapDay({ month: npc.birthMonth, day: npc.birthDay })
          ? 'birthday-today-leap'
          : 'birthday-today';
      results.push({ type, name: npc.name, target: 'other' });
    }
  }

  // 自分自身（明日）
  if (myself && isTomorrow({ month: myself.mBirthMonth, day: myself.mBirthDay })) {
    results.push({
      type: 'birthday-tomorrow',
      name: myself.mPNm,
      target: 'myself'
    });
  }

  // プレイヤーの島民（明日）
  for (const p of otherPlayers) {
    if (p.screening !== 'ng' && isTomorrow({ month: p.mBirthMonth, day: p.mBirthDay })) {
      results.push({ type: 'birthday-tomorrow', name: p.mPNm, target: 'other' });
    }
  }

  // NPCの島民（明日）
  for (const npc of npcs) {
    if (isTomorrow({ month: npc.birthMonth, day: npc.birthDay })) {
      results.push({ type: 'birthday-tomorrow', name: npc.name, target: 'other' });
    }
  }

  return results;
}
